var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu px-3 pt-3"},[_c('h6',[_vm._v("Chat Message\n    "),_c('label',{staticClass:"switch switch-text switch-pill switch-success switch-sm float-right"},[_c('small',{staticClass:"text-muted",staticStyle:{"font-size":"9px"},on:{"click":_vm.asideToggle}},[_vm._v("Fechar")])])]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261432e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/layout/Aside.vue
// module id = null
// module chunks = 